export const environment = {
  production: true,
  publicKey: 'public_g7X5Io353sByxktTNeYnUf+Sm00=',
  urlEndpoint: 'https://ik.imagekit.io/a5tyx88viji',
  DIRECTUS_URL: 'https://backend.mirkoreichlin.ch',
  DIRECTUS_TOKEN: 'YIDky47kJ_aE7PrcdbQfhwLNv2z0HL65'
};
